import React from 'react'

import { Button } from '_zari/core'

import { useHistory } from 'react-router-dom'

const RetrocederButton = () => {
  const history = useHistory()
  const retroceder = React.useCallback(() => {
    history.goBack()
  }, [history])

  return (
    <Button onClick={retroceder} color='secondary'>
      Cancelar
    </Button>
  )
}

export default React.memo(RetrocederButton)
